export function initialState (){
    return {
        tax_id: null,
        alnobj: null,
        options: null,
        alignments: null,
        proteinTypes: null,
        protein_type_obj: null,
        pdbs: [
            {id: "4v9d", name: "4V9D E. coli"},
            {id: "4v6u", name: "4V6U P. furiosus"},
            {id: "4v6x", name: "4V6X H. sapiens"},
            ],
        availColorschemes: [
            "nucleotide","purine_pyrimidine",
            ],
        available_properties: [
            {Name:"Shannon entropy", url:"static/alignments/svg/ShannonNA.svg"},
            ],
        selectAllProteinsChecked: false,
        selectedProteins: [],
        selectAllModifiedChecked: false,
        selectedResidues: [],
        selectAllModifiedCustomChecked: false,
        selectedResiduesCustom: [],
        domain_list: null,
        selected_domain: [],
        pdbid: null,
        chains: null,
        protein_chains: null,
        protein_contacts: null,
        proteinColorMap: null,
        chainid: [],
        pchainid: [],
        modified_residues: null,
        modified: false,
        modifications: [],
        viewer_options: null,
        mapped_aa_contacts_mods: new Map(),
        modifiedColorMap: null,
        unfilteredChains: null,
        entityID: null,
        fasta_data: null,
        fastaSeqNames: null,
        sequence: null,
        colorScheme: 'nucleotide',
        colorSchemeData: null,
        msavWillMount: null,
        aaPos: 0, seqPos: 0,
        hide_chains: null,
        type_tree: "orth",
        user_uploaded_cif_flag : null,
        aa_properties: null,
        structure_mapping: null,
        poor_structure_map: null,
        file: null,
        custom_aln_twc_flag: null,
        unmappedTWCdata: null,
        topology_loaded: false,
        twc_loaded: false,
        masking_range: null,
        mask_mode: 'highlight',
        cif_file_path: null,
        filter_range: null,
        correct_mask: null,
        mask_apply_attempted: false,
        domain_or_selection: null,
        checked_domain: false,
        checked_filter: false,
        checked_selection: false,
        checked_customMap: false,
        selected_property: null,
        selectSections_proteins: null,
        csv_data: null,
        custom_headers: [],
        raiseCustomCSVWarn: null,
        all_residues: null,
        coil_residues: null,
        helix_residues: null,
        strand_residues: null,
        substructures: null,
        property: null,
        uploadSession: false,
        fetchingPDBwithCustomAln: null,
        blastPDBresult: [],
        blastMAPresult: null,
        guideOff: true,
        postedPDBEntities: false,
        pdbStart: null,
        pdbEnd: null,
        pdbSeq: null,
        downloadAlignmentOpt: null,
        downloadMapDataOpt: null,
        freqCSV: null,
        cifPdbMode: null,
        customPDBsuccess: null,
        customPDBid: null,
        PDBparsing: false,
        checkedRNA: false,
        schemesMgr: null,
        didCDHit_truncate: null,
        cdhitSelectedOpt: null,
        cdHITReport: null,
        cdhitOpts: [
            {Name:'Download cdhit report', value:'download'},
            {Name:'Reload original alignment', value:'untrunc'}
        ],
        cifFileUploadedFlag: false,
        pdbFileUploadedFlag: false,
        RVGuideEntityId: -1,
        sequence_for_r2dt : null,
        json_structures_from_r2dt : null, 
        pdbdata: null,
        cifdata: null,
        pdbcust: null,
        cifcust: null,
        unfilteredChains_orig: null,
        associatedDataCache: null,
        associatedData1: null
    }
}
